import React from 'react';

const NotFoundRoute = () => {
  return (
    <p>This page cannot be found.</p>
  );
};

export default NotFoundRoute;
